export default __webpack_public_path__ + "static/media/ic-pin-purple.94c6808a.svg";